import { inject, Injectable, signal } from '@angular/core';

import { environment } from '@env/environment';
import { INST } from '@env/inst-type';
import { Guid } from '@models/base/helper-types';
import { Person } from '@models/users/person';
import { StoreService } from './store.service';

@Injectable({ providedIn: 'root' })
export class BaseService {

    readonly inst = INST;
    readonly env = environment;

    readonly isEnterprise = INST == 'enterprise';
    readonly isProd = environment.env == 'prod';

    readonly store      = inject(StoreService);

    readonly mobile     = signal<boolean | undefined>(undefined);
    readonly userId     = signal<Guid | undefined>(undefined);
    readonly user       = signal<Person | undefined>(undefined);
    readonly orgId      = signal<Guid | undefined>(undefined);
    readonly isGuest    = signal<boolean | undefined>(undefined);

}
